import TransactionLedger from "../components/TransactionLedger";
export default function IncomePage() {
  return <TransactionLedger type="income" />;
}
